<div ngModelGroup="comboAcaoAtividade-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboAcaoAtividade
                       nome="acao-atividade-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Descrição da Ação da Atividade"
                       label="Ação da Atividade"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>

